// extracted by mini-css-extract-plugin
module.exports = {"className":"Error500_className__aIenO","headline":"Error500_headline__b0_T0","messageContainer":"Error500_messageContainer___alcM","button":"Error500_button__9QSiV"};